<template>
  <v-container>
    <v-row justify="center">
      <ViewHeader :title="viewTitle" />
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="12">
            <v-card>
              <v-tabs
                v-model="active"
                background-color="primary"
                slider-color="warning"
                dark
              >
                <template v-for="tab in tabs">
                  <v-tab
                    :key="tab.id"
                    :to="tab.route"
                    ripple
                    v-if="tab.hasAccess"
                  >
                    {{ $t(tab.label) }}
                  </v-tab>
                </template>
              </v-tabs>
              <v-tabs-items v-model="active" @change="updateRouter($event)">
                <v-row no-gutters justify="center">
                  <v-col style="min-height: 650px; overflow: hidden;">
                    <transition name="fade" mode="out-in">
                      <router-view
                        class="animation-duration--500"
                      ></router-view>
                    </transition>
                  </v-col>
                </v-row>
              </v-tabs-items>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ViewHeader from "@/components/ui/ViewHeader.vue";

import cuid from "cuid";

export default {
  name: "UserSettings",
  components: {
    ViewHeader
  },
  data() {
    return {
      viewTitle: this.$t("message.common.userAccount"),
      active: 0,
      tabs: [
        {
          id: cuid(),
          label: "message.common.userProfile",
          route: { name: "user-settings-user-profile" },
          hasAccess: true
        },
        {
          id: cuid(),
          label: "message.common.consentsAndRegulations",
          route: { name: "user-settings-consents-and-regulations" },
          hasAccess: true
        },
        {
          id: cuid(),
          label: "message.common.subscription",
          route: { name: "subscription-settings" },
          hasAccess: this.$hasAccess(this.$permission.MANAGE_COMPANY_DATA)
        }
      ]
    };
  },
  methods: {
    updateRouter(val) {
      this.$router.push(val);
    }
  }
};
</script>

<style lang="scss" scoped></style>
